'use client';

import { c as _c } from "react/compiler-runtime";
export default function ServiceCastBlockChat() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mb-[3px] whitespace-pre-wrap text-cht_al_co"><div>{"\uC77C\uBCF8 \uC1A1\uCD9C\uC774 \uC911\uB2E8\uB418\uC5C8\uC2B5\uB2C8\uB2E4."}</div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}